import React from "react"
import { useTheme } from "react-jss"
import { useTranslation } from "react-i18next"
import classNames from 'classnames'

import { retryOrder } from '@portal/kit/pkg/services'
import { redirectToBank } from '@portal/kit/pkg/helpers'
import { Button, ContentBox, Notification, FormButtons } from "@portal/kit/pkg/components"

import styles from './styles'

export default function Subscription({ subscription }) {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const classes = styles(theme)

  const { is_unpaid, order_id, offer } = subscription

  const isUnpaid = is_unpaid && (subscription.regularization_link || order_id)

  const retryPayment = async () => {
    // Subscription made by stripe
    if (subscription.regularization_link) {
      window.location.replace(subscription.regularization_link)
      return
    }

    try {
      const response = await retryOrder(
        null,
        order_id,
        `/offers/${offer.id}/regularization/:order_id`,
      )
      redirectToBank(response.data)
    }
    catch (e) {
      // handleOrderErrors(e)
    }
  }

  return (
    <ContentBox title={t('internet_access.subscription')} titleIcon="wifi">
      {isUnpaid && <Notification status="fail" message={t('subscription.unpaid.content')}>
        <div><Button onClick={retryPayment}>{t('subscription.buttons.regularize')}</Button></div>
      </Notification>}

      <div className={classes.internetAccessText}>
        <span className={classNames('fal', 'fa-wifi', classes.internetAccessIcon)} />
        {t('subscription.internet_access.offer', { offer: offer.locales[i18n.language].name })} :
        <div>{t(offer.locales[i18n.language].description_3) }</div>
      </div>

      <FormButtons>
        <Button classType="cancel" to='/my-account/subscriptions'>{t('subscription.buttons.handle')}</Button>
      </FormButtons>
    </ContentBox>
  )
}
